import { createRouter, createWebHistory } from 'vue-router'
import Apps from '../views/Apps.vue'
import store from '../store'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/Login.vue'),
    meta: {
      title: `เข้าสู่ระบบ`,
    }
  },
  {
    path: '/',
    name: 'home',
    component: Apps,
    redirect: 'dashboard',
    meta: {
      requiresAuth: true,
      title: `หน้าหลัก`,
      roles: ['admin', 'manager', 'user'],
    },
    children: [
      {
        path: '/test',
        name: 'test',
        component: () => import('@/views/Test.vue'),
        meta: {
          title: `Test`
        }
      },
      {
        path: '',
        name: 'dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: {
          title: `หนัาหลัก`
        }
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/Profile.vue'),
        meta: {
          title: `ข้อมูลส่วนตัว`
        }
      },

      {
        path: '/doctor',
        name: 'doctor',
        component: () => import('@/views/Doctor.vue'),
        meta: {
          title: `รายชื่อแพทย์`
        }
      },
      {
        path: '/leave-types',
        name: 'leavetypes',
        component: () => import('../views/LeaveType.vue'),
        meta: {
          title: `ประเภทการลา`
        }
      },
      {
        path: '/leave-work',
        name: 'leavework',
        component: () => import('@/views/LeaveWork.vue'),
        meta: {
          title: `บันทึกการลา`
        }
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {

  document.title = `${to.meta.title} | ${process.env.VUE_APP_NAME_EN}`

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      next({
        name: 'login',
      });
    }
    // next();
    // console.log(store.state.role);
    if (to.meta?.roles?.includes(store.state.role)) {
      next()
    } else {
      next({ name: "dashboard" })
    }
  } else {
    next();
  }
});

export default router
